import { Injectable } from '@angular/core';
import { DashboardNavigationServiceBase } from 'src/shared/services/dashboard-navigation-service-base';

@Injectable({
    providedIn: 'root'
})
export class DashboardNavigationService extends DashboardNavigationServiceBase {
    constructor() {
        super(true);
    }
}
